
// DO NOT DIRECTLY MODIFY THIS FILE
// It was generated automatically, from the C# file: DataType.cs
// Any changes made directly here would be lost next time the C# class was changed

// It was created using Visual Studio extension 'TypeWriter', using the template in VueModels.tst
// More info: http://frhagn.github.io/Typewriter/






export enum DataType { 
    Song = 1,
    Arrangement = 2,
}